import React, { useState, useEffect } from 'react';
import { FiSave, FiX, FiUpload, FiUser, FiCalendar, FiClock, FiFileText, FiPaperclip, FiCheckCircle } from 'react-icons/fi';
import { toast } from 'react-toastify';
import Api from '../../Api';
import Button from '../Button';
import Input from '../Input';
import Select from '../Select';
import '../CompanyForm/style.css';

export default function AdjustmentForm({ initialData, companyId, onSuccess, onCancel }) {
  const [formData, setFormData] = useState({
    employee_id: '',
    date: '',
    reason: '',
    requested_times: '',
    attachment: null,
    status: 'pending',
  });
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    loadEmployees();
    if (initialData) {
      setFormData({
        employee_id: initialData.employee_id,
        date: initialData.date,
        reason: initialData.reason,
        requested_times: Array.isArray(initialData.requested_times) 
          ? initialData.requested_times.join(', ') 
          : initialData.requested_times || '',
        attachment: initialData.attachment,
        status: initialData.status,
      });
    }
  }, [initialData]);

  async function loadEmployees() {
    try {
      const data = await Api.getEmployees(companyId);
      if (Array.isArray(data)) {
        setEmployees(data.map(emp => ({ label: emp.name, value: emp.id })));
      }
    } catch (err) {
      console.error('Error loading employees', err);
    }
  }

  function handleChange(e) {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  }

  function handleFileChange(e) {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData(prev => ({ ...prev, attachment: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const payload = {
        ...formData,
        requested_times: formData.requested_times.split(',').map(t => t.trim()),
      };

      if (initialData) {
        await Api.updateAdjustment(companyId, initialData.id, payload);
        toast.success('Solicitação atualizada com sucesso!');
      } else {
        await Api.createAdjustment(companyId, payload);
        toast.success('Solicitação criada com sucesso!');
      }
      onSuccess();
    } catch (err) {
      setError('Erro ao salvar solicitação.');
      toast.error('Erro ao salvar solicitação.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <form onSubmit={handleSubmit} className="company-form-component">
      <div className="form-body">
        <h3 className="section-title" style={{ marginTop: '0px' }}>Dados da solicitação</h3>
        
        {error && <div className="form-error">{error}</div>}

        <div className="form-grid">
          <div className="full-width">
            <Select
              label="Funcionário"
              name="employee_id"
              value={formData.employee_id}
              onChange={handleChange}
              options={employees}
              disabled={!!initialData}
              required
              icon={FiUser}
              searchable
            />
          </div>

          <Input
            label="Data"
            name="date"
            type="date"
            value={formData.date}
            onChange={handleChange}
            required
            icon={FiCalendar}
          />

          <Input
            label="Horários Solicitados"
            name="requested_times"
            value={formData.requested_times}
            onChange={handleChange}
            placeholder="Ex: 08:00, 12:00, 13:00, 17:00"
            icon={FiClock}
          />

          <div className="full-width">
            <Input
              label="Motivo"
              name="reason"
              value={formData.reason}
              onChange={handleChange}
              required
              icon={FiFileText}
              multiline
              rows={5}
            />
          </div>

          <div className="full-width">
            <label style={{ 
              display: 'block', 
              fontSize: '0.9rem', 
              fontWeight: 500, 
              color: 'var(--text-primary)', 
              marginBottom: '0.5rem' 
            }}>
              Comprovante (Opcional)
            </label>
            <div style={{ 
              border: '1px dashed var(--border-color)', 
              padding: '1rem', 
              borderRadius: '6px', 
              textAlign: 'center',
              cursor: 'pointer',
              backgroundColor: 'var(--background-color)'
            }} onClick={() => document.getElementById('file-upload').click()}>
              <input
                id="file-upload"
                type="file"
                accept="image/*,.pdf"
                onChange={handleFileChange}
                style={{ display: 'none' }}
              />
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem', color: 'var(--text-secondary)' }}>
                {formData.attachment ? (
                  <>
                    <FiCheckCircle size={24} color="var(--success-color)" />
                    <span style={{ color: 'var(--success-color)' }}>Arquivo selecionado</span>
                  </>
                ) : (
                  <>
                    <FiPaperclip size={24} />
                    <span>Clique para anexar um arquivo (Imagem ou PDF)</span>
                  </>
                )}
              </div>
            </div>
          </div>

          {initialData && (
            <div className="full-width">
              <Select
                label="Status"
                name="status"
                value={formData.status}
                onChange={handleChange}
                options={[
                  { label: 'Pendente', value: 'pending' },
                  { label: 'Aprovado', value: 'approved' },
                  { label: 'Rejeitado', value: 'rejected' },
                ]}
                icon={FiCheckCircle}
              />
            </div>
          )}
        </div>
      </div>

      <div className="form-actions">
        <Button 
          type="button" 
          className="cancel-button" 
          onClick={onCancel}
          disabled={loading}
        >
          Cancelar
        </Button>
        <Button type="submit" loading={loading}>
          <FiSave />
          Salvar
        </Button>
      </div>
    </form>
  );
}
